import { render, staticRenderFns } from "./OrdenTrabajoField.vue?vue&type=template&id=f0d97514&scoped=true"
import script from "./OrdenTrabajoField.vue?vue&type=script&lang=js"
export * from "./OrdenTrabajoField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0d97514",
  null
  
)

export default component.exports